import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { usePanelConfig } from "./usePanelConfig";
import { formatDate } from "../../../utils/date";
import { getUsername } from "../../../ducks/user";
import { useProjectTitle, useProjectInfo } from "../../../ducks/project/hooks";

export const useProjectPanel = () => {
  const [project] = useProjectInfo();
  const username = useSelector(getUsername);
  const config = usePanelConfig();
  const title = useProjectTitle();
  const { t } = useTranslation("projectPanel");

  const projectLabel = useMemo(
    () => project && `${t("lastUpdated")}: ${formatDate(project.changedDate)}`,
    [project, t],
  );

  const disabled = !project.name;

  const preloadText = disabled ? `${t("loadingMap")}...` : username === project.owner ? projectLabel : project.owner;

  return {
    title,
    disabled,
    config,
    preloadText,
    projectName: project.name,
  };
};
